import $ from 'jquery';
import "jquery.easing";

import { themePath } from './_global.js';

$(function(){
	
	// open form
	$('.opencform').click(function(e){
		e.preventDefault();
		$('.cform').slideDown(400, 'easeOutQuad');
		$('.opencform').addClass('active');
		$('html, body').animate({
			scrollTop: $('.cform').offset().top + 1
		}, 400, 'easeInOutQuad');	
	});
	
	// close form
	$('.cform .close').click(function(e){
		e.preventDefault();
		$('.cform').slideUp(500, 'easeOutQuint');
		$('.opencform').removeClass('active');
	})
	
	// labels
	var $labels = $('.cform label');
	$labels.each(function(){
		var $label = $(this);
		$label.find('input, textarea')
			.focus(function(){
				$label.removeClass('empty');
			})
			.blur(function(){
				$(this).val($(this).val().trim());
				if($(this).val().length == 0) $label.addClass('empty');
			})
			.trigger('blur');
	});
	
	// submit form
	$('.cform form').submit(function(e){
		
		e.preventDefault();
	
		var $form = $(this);
		var $name = $form.find('#name');
		var $phone = $form.find('#phone');
		var $email = $form.find('#email');
		var $company = $form.find('#company');
		var $message = $form.find('#message');
		
		var emailreg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,16})$/;
		
		$form.find('.error').each(function(){
			$(this).removeClass('error');
			$(this).siblings('p').remove();
		});
		$form.find('.send-error').remove();
		
		$name.val($name.val().trim());
		$phone.val($phone.val().trim());
		$email.val($email.val().trim());
		$company.val($company.val().trim());
		$message.val($message.val().trim());
		
		if($name.val().length == 0) {
			$name.addClass('error');
			cFieldError($name, 'Your name is required.');
		}
		if($phone.val().length == 0) {
			$phone.addClass('error');
			cFieldError($phone, 'Your phone number is required.');
		}
		if($email.val().length == 0) {
			$email.addClass('error');
			cFieldError($email, 'Your email address is required.');
		}
		else if(!emailreg.test($email.val())) {
			$email.addClass('error');
			cFieldError($email, 'Your email address is invalid.');
		}
		if($message.val().length == 0) {
			$message.addClass('error');
			cFieldError($message, 'Your message is required.');
		}
		
		if($form.find('.error').length == 0) {
			$.get(GLOBALS?.AJAX_URL, {
				action: 'orangery_theme_submit_contact',
				name: $name.val(),
				phone: $phone.val(),
				email: $email.val(),
				company: $company.val(),
				message: $message.val()
			})
			.done(function(json){
				const response = JSON.parse(json);

				if(response?.success) {
					cFormSuccess();
				}
				else {
					cFormError();
				}
			})
			.fail(function(jqxhr, textStatus, error){
				cFormError();
			});	
		}
		
	});
	
	
	// validation error messages
	function cFieldError($field, message) {
		$field.parent().append('<p>'+message+'</p>');
	}
	
	// clear validation errors
	$('.cform form').on('focus click change', '.error', function(){
		$(this).removeClass('error');
		$(this).siblings('p').remove();
	});
	
	// success
	function cFormSuccess(){
		$('.cform form').slideUp(200, 'easeInQuad', function(){
			$('.cform h4').text('Thanks for getting in touch!');
			$('.cform .success').slideDown(200, 'easeOutQuad');	
		});
		$('html, body').animate({
			scrollTop: $('.cform').offset().top + 1
		}, 400, 'easeInOutQuad');
	}
	
	// failure
	function cFormError(){
		$('.cform form #message').parent().append('<p class="send-error">An error occurred - please try again.</p>');
	}
	
	
});